__turbopack_context__.v({
  "button": "_5h0nca_button",
  "container": "_5h0nca_container",
  "description": "_5h0nca_description",
  "header": "_5h0nca_header",
  "title": "_5h0nca_title",
});
